export default "__VITE_ASSET__5efa4fdb__"